import logo from 'assets/footerLogo.png';
import { Col, Container, Nav, Row } from "react-bootstrap";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { CiLocationOn } from "react-icons/ci";
import { MdOutlineMailOutline } from "react-icons/md";
import { FiPhone } from "react-icons/fi";
import { Link } from 'react-scroll';
import { footernav } from 'components/MenuItems';
import { useState } from 'react';
import footer from 'assets/footerHeading.png'
const Footer = () => {
    const [activeLink, setActiveLink] = useState("");

    return (
        <div style={{ backgroundColor: "#090023" }} className='text-white'>

            <Container className='px-4 py-5 '>

                <Row className='align-items-center'>
                    <Col lg={3}>

                        <div className='logo  footerLogo mb-1' >
                            <img src={logo} alt="footer Logo " className="img-fluid" />
                        </div>

                        <div className="d-flex gap-4">
                            {/* 
                            <p className="icon">
                                <FaFacebookF />
                            </p>
                        */}
                            <a className="icon" href="https://www.instagram.com/livingwall.au/" target="_blank" rel="noopener noreferrer">
                                <FaInstagram />
                            </a>
                            <a className="icon" href="https://www.linkedin.com/company/livingwall/" target="_blank" rel="noopener noreferrer">
                                <FaLinkedinIn />
                            </a>
                            {/* <p className="icon">
                                <FaXTwitter />
                            </p> */}
                        </div>
                    </Col>

                    <Col lg={6} className='d-lg-flex  mb-lg-0 mb-3 justify-md-content-center'>

                        <Nav className="mx-md-auto gap-lg-3">
                            {footernav?.map((tab) => (
                                <Link
                                    key={tab?.label}
                                    to={tab?.path}
                                    duration={1000}
                                    className={`nav-link text-white border-0 pointer ${activeLink === tab?.path ? 'ActiveLink' : ''}`}
                                    onSetActive={() => setActiveLink(tab?.path)}
                                >
                                    {tab?.label}
                                </Link>
                            ))}
                        </Nav>

                    </Col>

                    <Col lg={3}>


                        <ul className="list-unstyled">
                            <li>
                                <CiLocationOn className='fs-4 mb-1' color='var(--color4)' />
                                <span className="ps-2">
                                    5 Creative St,  Wangara WA 6065
                                </span>
                            </li>
                            <li>
                                <FiPhone className='fs-4 mb-1' color='var(--color4)' />
                                <span className="ps-2">
                                    1300 987 918
                                </span>
                            </li>
                            <li>
                                <MdOutlineMailOutline className='fs-4 mb-1' color='var(--color4)' />
                                <span className="ps-2">
                                    info@livingwall.au
                                </span>
                            </li>
                        </ul>
                    </Col>
                </Row>
                <div className='d-flex justify-content-center'>
                    <img src={footer} alt="LIVING WALLS" className='img-fluid ' />
                </div>
                <p style={{ color: "#8A8A8A" }} className="pt-5 text-center">© 2024 Living Wall All rights reserved.</p>
            </Container>

        </div >
    );
};

export default Footer;
